export function slug<E extends string>(e: E): string {
    return e.toLowerCase().replace('_', '-')
}
export function fromSlug<E>(slug: string, type: {[key: string]: E}): E {
    return type[slug.toUpperCase().replace('-', '_')]
}